<script setup lang="ts">
import ChapterShortQuestionsPage from "~/features/computer/components/ChapterShortQuestionsPage.vue";
</script>

<template>
  <ChapterShortQuestionsPage unit="digital-literacy" />
</template>
